import { render } from "./StatusReasonModal.vue?vue&type=template&id=0f4d22fa"
import script from "./StatusReasonModal.vue?vue&type=script&lang=js"
export * from "./StatusReasonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__